import { getCurrentInstance, computed } from '@vue/composition-api'

export default function useI18n () {
  const vm = getCurrentInstance()
  if (!vm) throw new Error('Must be called in setup')

  const i18n = computed(() => vm.proxy.$i18n)
  return i18n
}
